import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { SellinDetailModalComponent } from '../sellin-detail-modal/sellin-detail-modal.component';

@Component({
  selector: 'app-dealer-sell-in',
  templateUrl: './dealer-sell-in.component.html',
  styleUrls: ['./dealer-sell-in.component.css']
})
export class DealerSellInComponent {

  
  @ViewChild(SellinDetailModalComponent) 
  private SellinDetailModalComponent!:SellinDetailModalComponent;

  @Input() isLoading : boolean = false;
  @Input() message : String = "";
  @Input() sellInData : Array<any> = [];
  @Input() currentTab : string = "";
  isMobile : boolean = false;
  @Output() updateTpNameFilter = new EventEmitter<Sort>();

  constructor(
    public globalservice : GlobalService
  ){}

  ngOnInit(){
    this.isMobile = this.globalservice.isMobile();
  }
  
  sortData(sort:Sort){
    this.updateTpNameFilter.emit(sort);
  }
  
  onClickRow(data:any){
    this.SellinDetailModalComponent.setSellInData(data);
  }
}
